import { IStateAction, IStateManagedEntity } from "./state-action";

export class SetItemsAction<T extends IStateManagedEntity>
  implements IStateAction<T>
{
  constructor(private newElements: T[]) {}

  execute(elements: T[]): T[] {
    return [...this.newElements];
  }
}

export class AddItemAction<T extends IStateManagedEntity>
  implements IStateAction<T>
{
  constructor(private element: T) {}

  execute(elements: T[]): T[] {
    return [...elements, this.element];
  }
}

export class UpdateItemAction<T extends IStateManagedEntity>
  implements IStateAction<T>
{
  constructor(
    private id: string,
    private element: Partial<T>,
  ) {}

  execute(elements: T[]): T[] {
    return [
      ...elements.map((e) => {
        if (e.id === this.id) {
          return Object.assign(e, {
            ...this.element,
          });
        } else {
          return e;
        }
      }),
    ];
  }
}
